import * as actionType from './type';

const INITIAL_STATE = {
    merchant: [],
    isLoading: false,
    error: ""
}

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case actionType.REQUEST_GET_ALL_MERCHANTS: {
            return {
                ...state,
                isLoading: true
            }
        }

        case actionType.RECEIVED_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: "Please try again"
            }
        }

        case actionType.RECEIVED_GET_ALL_MERCHANTS: {
            return {
                ...state,
                isLoading: false,
                merchant: action.payload
            }
        }

        default: 
            return state;
    }
}